import { Environment } from './environment.interface';

export const environment: Environment = {
  apiUrl: 'https://dev.secrets.planikun.com/api',
  firebaseConfig: {
    projectId: 'planikun-dev',
    appId: '1:643099410948:web:cf9bd81f746d8928dceb51',
    storageBucket: 'planikun-dev.appspot.com',
    apiKey: 'AIzaSyAVXtKZhKsLXvokKOjh77Wqj_VHry6ERvc',
    authDomain: 'planikun-dev.firebaseapp.com',
    messagingSenderId: '643099410948',
    measurementId: 'G-EYYWR3PQJT'
  },
  production: false,
  usingMocks: false,
};
